import React, { useCallback, useMemo, useState } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import ApiService from '@common/services/ApiService';
import { DefaultModal } from '@common/components/default-modal';
import { DefaultButton } from '@common/components/default-button';
import { withStyles } from 'tss-react/mui';
import { unitResponsesStyles } from './styles';
import { vcmComponentStatusOptions } from './options';

const api = new ApiService();
const VcmRejectModal = ({
  classes,
  isOpened,
  onClose,
  onRefresh,
  unitResponses,
  vcmProfessionalQualifications,
  vcm
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const canRejectVcm = useMemo(
    () =>
      (unitResponses.some(
        (unitResponse) =>
          unitResponse.status ===
          vcmComponentStatusOptions.needs_attention.id
      ) ||
        vcmProfessionalQualifications.some(
          (vcmProfessionalQualification) =>
            vcmProfessionalQualification.status ===
            vcmComponentStatusOptions.needs_attention.id
        )) &&
      unitResponses.every(
        (unitResponse) =>
          unitResponse.status ===
            vcmComponentStatusOptions.needs_attention.id ||
          unitResponse.status === vcmComponentStatusOptions.approved.id
      ) &&
      vcmProfessionalQualifications.every(
        (vcmProfessionalQualification) =>
          vcmProfessionalQualification.status ===
            vcmComponentStatusOptions.needs_attention.id ||
          vcmProfessionalQualification.status ===
            vcmComponentStatusOptions.approved.id
      ),
    [unitResponses, vcmProfessionalQualifications]
  );

  const handleSubmit = useCallback(async () => {
    setIsLoading(true);

    try {
      const url = `/api/v1/vcms/${vcm.id}/reject`;
      const res = await api.put(url);

      if (res.status === 200) {
        handleClose();
        onRefresh();
      } else if (res.status === 422 || res.status === 400) {
        setErrorMessage(res.json.message);
      } else {
        console.error('Unknown response', res);
      }
    } catch (error) {
      setErrorMessage(error.message);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const handleClose = useCallback(() => {
    setErrorMessage(null);
    onClose();
  }, [setErrorMessage, onClose]);

  return (
    <DefaultModal
      isOpened={isOpened}
      isLoading={isLoading}
      onClose={handleClose}
      title="Return VCM to Educator"
      action={
        canRejectVcm ? (
          <DefaultButton
            className={classes.button}
            color="secondary"
            onClick={handleSubmit}
            size="small"
            variant="contained"
          >
            Return to educator
          </DefaultButton>
        ) : (
          <DefaultButton
            className={classes.button}
            onClick={handleClose}
            size="small"
            variant="contained"
          >
            Close
          </DefaultButton>
        )
      }
    >
      <Grid container spacing={2}>
        <Grid size={12}>
          <Typography color="error">{errorMessage}</Typography>
        </Grid>
        <Grid size={12} mb={4}>
          <Typography>
            {canRejectVcm
              ? "This will notify the Educator that the VCM is not yet approved and the qualifications or units marked 'Needs attention' need to be corrected."
              : 'You must action all professional qualifications and unit responses first prior to returning the VCM back for attention and at least one item must be marked for attention.'}
          </Typography>
        </Grid>
      </Grid>
    </DefaultModal>
  );
};

export default withStyles(VcmRejectModal, unitResponsesStyles, {
  withTheme: true
});
